import React from 'react';
import type { FC } from 'react';

import { CONTACTS, MAX_URL } from '../../data/config';
import {
    BrandMarkIcon,
    DepartmentMarkIcon,
    MailIcon,
    TrendChartIcon,
} from '../../assets/icons/icons';
import styles from './BrandPanel.module.scss';
import { QrCode } from '../../assets/qrCode';

interface BrandPanelProps {
    onOpenQr: () => void;
}

export const BrandPanel: FC<BrandPanelProps> = ({ onOpenQr }) => (
    <section className={styles.panel}>
        <div className={styles.logo}>
            <BrandMarkIcon className={styles.brandMark} />

            <div className={styles.brandName}>
                <b>
                    Предиктивная
                    <br />
                    аналитика
                </b>
            </div>

            <span className={styles.divider} aria-hidden="true" />

            <div className={styles.dept}>
                <DepartmentMarkIcon className={styles.deptMark} />
                <div className={styles.deptName}>
                    <span>Ямало-Ненецкий автономный округ</span>
                    <span>Департамент государственного заказа</span>
                </div>
            </div>
        </div>

        <div className={styles.main}>
            <div className={styles.kicker}>Единая система анализа рыночных цен</div>

            <h1 className={styles.title}>Рыночные данные — в понятном и управляемом виде</h1>

            <p className={styles.lead}>
                Сервис помогает находить предложения, сопоставлять цены и быстрее принимать решения по
                закупочным позициям.
            </p>

            <div className={styles.visual} aria-hidden="true">
                <div className={styles.visualValue}>Аналитика в одном интерфейсе</div>
                <div className={styles.chart}>
                    <TrendChartIcon />
                </div>
            </div>
        </div>

        <div className={styles.footer}>
            <div className={styles.maxBlock}>
                <button
                    type="button"
                    className={styles.qrButton}
                    onClick={onOpenQr}
                    aria-label="Открыть QR-код MAX"
                >
                    <QrCode role="img" aria-label="QR-код для перехода в MAX" />
                </button>

                <div className={styles.maxCopy}>
                    <div className={styles.maxTitle}>Получайте уведомления в MAX</div>
                    {/* <div className={styles.maxSubtitle}>Статусы проектов и важные события сервиса.</div> */}
                    <a className={styles.maxLink} href={MAX_URL} target="_blank" rel="noopener noreferrer">
                        Перейти в MAX
                        <span aria-hidden="true">↗</span>
                    </a>
                </div>
            </div>

            <div className={styles.contacts}>
                {/* <a href={`tel:${CONTACTS.phoneHref}`}>
                    <PhoneIcon />
                    {CONTACTS.phone}
                </a> */}

                {/* <a href={`mailto:${CONTACTS.email}`}>
                    <MailIcon />
                    {CONTACTS.email}
                </a> */}

                <div className={styles.copyright}>© 2020–2026 Сервис Предиктивной Аналитики</div>
            </div>
        </div>
    </section>
);